import {
  createStandardAction,
  ActionType,
  createReducer,
} from 'typesafe-actions';
import produce from 'immer';

/**
 * Video 태그 상태
 */

// const CAN_PLAY = "video/CAN_PLAY";
const PLAYING = 'video/PLAYING';
const PAUSE = 'video/PAUSE';
const ENDED = 'video/ENDED';
const SEEKING = 'video/SEEKING';
const SEEKED = 'video/SEEKED';
const TIME_UPDATE = 'video/TIME_UPDATE';
const ERROR = 'video/ERROR';

const MANIFEST_PARSED = 'video/MANIFEST_PARSED';

const SET_PLAYING_TIME = 'video/SET_PLAYING_TIME';
const CHANGE_VIDEO_DOM = 'video/CHANGE_VIDEO_DOM';
const PRELOAD = 'video/PRELOAD';

// export const canPlayAction = createStandardAction(CAN_PLAY)<
//     HTMLVideoElement,
//     number
// >();
export const playingAction = createStandardAction(PLAYING)();
export const pauseAction = createStandardAction(PAUSE)();
export const endedAction = createStandardAction(ENDED)();
export const seekingAction = createStandardAction(SEEKING)<number>();
export const seekedAction = createStandardAction(SEEKED)();
export const timeUpdateAction = createStandardAction(TIME_UPDATE)<number>();
// number
export const errorAction = createStandardAction(ERROR)();

export const manifestParsedAction = createStandardAction(MANIFEST_PARSED)<
  HTMLVideoElement,
  number
>();

export const changeVideoDomAction =
  createStandardAction(CHANGE_VIDEO_DOM)<HTMLVideoElement>();
export const preloadAction = createStandardAction(PRELOAD)<boolean>();
export const setPlayingTimeAction =
  createStandardAction(SET_PLAYING_TIME)<number>();

type actions = {
  // canPlayAction,
  playingAction: typeof playingAction;
  pauseAction: typeof pauseAction;
  endedAction: typeof endedAction;
  seekingAction: typeof seekingAction;
  seekedAction: typeof seekedAction;
  timeUpdateAction: typeof timeUpdateAction;
  errorAction: typeof errorAction;
  manifestParsedAction: typeof manifestParsedAction;
  changeVideoDomAction: typeof changeVideoDomAction;
  preloadAction: typeof preloadAction;
  setPlayingTimeAction: typeof setPlayingTimeAction;
};
type VideoAction = ActionType<actions>;

type VideoState = {
  waiting: boolean;
  paused: boolean;
  ended: boolean;
  seeking: boolean;
  nextPreload: boolean;
  playingTime: number;
  currentMediaTime: number;
  totalDuration: number;
  videoDOM: HTMLVideoElement | null;
  // nextVideoDOM: HTMLVideoElement | null;
};

const initialState: VideoState = {
  waiting: true,
  paused: true,
  ended: false,
  seeking: false,
  nextPreload: false,
  playingTime: 0,
  currentMediaTime: 0,
  totalDuration: 0,
  videoDOM: null,
  // nextVideoDOM: null,
};

const video = createReducer<VideoState, VideoAction>(initialState, {
  [SET_PLAYING_TIME]: (state, action) => ({
    ...state,
    ...action,
    playingTime: Number(action.payload.toFixed(2)),
  }),
  [PRELOAD]: (state, action) => ({
    ...state,
    ...action,
    nextPreload: action.payload,
  }),
  [CHANGE_VIDEO_DOM]: (state, action) => ({
    ...state,
    ...action,
    videoDOM: action.payload,
  }),
  [MANIFEST_PARSED]: (state, {payload: videoDOM, meta: totalDuration}) =>
    produce(state, (draft) => {
      draft.waiting = false;
      draft.ended = false;
      draft.videoDOM = videoDOM as any;
      draft.totalDuration = totalDuration;
    }),
  // [CAN_PLAY]: (state, action) => ({
  //     ...state,
  //     ...action,
  //     waiting: false,
  //     ended: false,
  //     videoDOM: action.payload,
  //     totalDuration: action.meta,
  // }),
  [PLAYING]: (state, action) => ({
    ...state,
    ...action,
    waiting: false,
    paused: false,
    ended: false,
  }),
  [PAUSE]: (state, action) => ({
    ...state,
    ...action,
    paused: true,
  }),
  [ENDED]: (state, action) => ({
    ...state,
    ...action,
    ended: true,
  }),
  [SEEKING]: (state, action) => ({
    ...state,
    ...action,
    seeking: true,
    playingTime: Number(action.payload.toFixed(2)),
  }),
  [SEEKED]: (state, action) => ({
    ...state,
    ...action,
    seeking: false, // seek가 끝나면 seeked 이벤트 들어옴, 이때 false로 줌
  }),
  [TIME_UPDATE]: (state, action) => ({
    ...state,
    ...action,
    // playingTime: action.payload,
    currentMediaTime: Number(action.payload.toFixed(2)),
  }),
  [ERROR]: (state, action) => ({
    ...state,
    ...action,
    ended: true,
  }),
});

export default video;
